import { render, staticRenderFns } from "./docs.page.vue?vue&type=template&id=604b5404&scoped=true&"
import script from "./docs.page.vue?vue&type=script&lang=js&"
export * from "./docs.page.vue?vue&type=script&lang=js&"
import style0 from "./docs.page.vue?vue&type=style&index=0&id=604b5404&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604b5404",
  null
  
)

export default component.exports